// extracted by mini-css-extract-plugin
module.exports = {"body":"ShowStablePopouts_body__1VMWM"};